module.exports = require("@tronweb3/google-protobuf/google/protobuf/any_pb.js");